/**
 * Rocksoft Places API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ModelNameFlags = {
    None: 'None',
    IPhone: 'iPhone',
    IPad: 'iPad',
    AppleTv: 'AppleTV',
    IPod: 'iPod',
    All: 'All',
} as const;
export type ModelNameFlags = typeof ModelNameFlags[keyof typeof ModelNameFlags];

